// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2nWV-","row":"ProcedureTreatmentSummary_row__2FLzr"};